<script setup lang="ts">
  import MainLayout from 'views/layouts/MainLayout.vue'
  import BannerAssineHorizontal from 'components/HomePage/BannerAssineHorizontal.vue'
  import Home from 'components/Afiliados/Home.vue'
  import CollapseBox from 'components/Afiliados/CollapseBox.vue'
</script>
<script lang="ts">
  import { defineComponent } from 'vue'
  import api from '../../api'
  import { mapState } from 'pinia'
  import { localeStore } from 'stores/locale'
  import tradutor from 'tradutors/afiliados'
  import Formulario from '../../components/Afiliados/Inscricao/Formulario.vue'
  import { isMobile } from "../shared/utils/mobile";

  export default defineComponent({
    name: 'AfiliadosInfoView',
    head() {
      return {
        templateParams: {
        subTitle: null, 
          subPage: this.translate.title,
          page_url: window.location.origin + this.$route.fullPath,
          page_description:
            this.locale === 'pt-br'
              ? `Ganhe dinheiro com o Bella da Semana recebendo comissões fixas.`
              : `Earn money with Bella Club by receiving fixed commissions.`,
          page_image: '/favicon.ico',
          page_keywords:
            'bella, bella da semana, bela da semana, bella semana, bela semana, belladasemana, bella site, bella da semana site',
          page_locale: this.locale,
          page_url_pt: 'https://belladasemana.com.br/pt-br/programa-afiliados',
          page_url_en: 'https://belladasemana.com.br/en/programa-afiliados',
          page_canonical: 'https://belladasemana.com.br' + this.$route.fullPath
        }
      }
    },
    computed: {
      ...mapState(localeStore, ['locale']),
      translate: function () {
        if (this.locale === 'pt-br') {
          return tradutor.portugues
        } else {
          return tradutor.ingles
        }
      }
    },
    watch: {
      locale: function () {
        this.getBannerAssineHorizontal(true)
      }
    },
    mounted() {
      this.getBannerAssineHorizontal()
    },
    data() {
      return {
        bannerAssineHorizontal: '',
        component: this.setComponent(),
        isMobile: isMobile(),        
      }
    },
    created() {
      const lang = ['pt-br', 'en']
      if (lang.indexOf(this.$route.params.locale) === -1) {
        window.location.replace('/')
      }
    },
    methods: {
      setComponent() {
        switch (this.$route.params.complement) {
          case 'subscribe': return 1
          case 'faq': return 2
          default: return 0
        }
      },
      async getBannerAssineHorizontal(changeLanguage = false) {
        if (!sessionStorage.getItem('bannerAssineHorizontal') || changeLanguage)
          api.get(`v1/home/getBannerSuper?mobile=${isMobile()}&language=${this.locale}`).then(({ data }) => {
            this.bannerAssineHorizontal = data.bannerAssineHorizontal
            sessionStorage.setItem(
              'bannerAssineHorizontal',
              JSON.stringify(this.bannerAssineHorizontal)
            )
          })
        else
          this.bannerAssineHorizontal = JSON.parse(sessionStorage.getItem('bannerAssineHorizontal'))
      }
    }
  })
</script>
<template>
  <MainLayout>
    <div class="slot-body">
      <main id="afliados" class="l-main">
        <div class="post">
          <div class="block block--white mt-1">
            <div class="container ct-top">
              <div class="post__body mt-4">
                <Home v-if="component === 0" />
                <CollapseBox
                  :list="translate.list"
                  :title="translate.title"
                  :subTitle="translate.subTitle"
                  v-if="component === 2"
                />
                <Formulario v-if="component === 1"/>
              </div>
            </div>
          </div>
          <div class="py-5">
            <BannerAssineHorizontal :path="bannerAssineHorizontal" />
          </div>
        </div>
      </main>
    </div>
  </MainLayout>
</template>
